import React, { useState, useEffect } from "react";
import Select from "react-select";
import ContinueButton from "../../Registration/ContinueButton";
import CollapsibleSections from "./DiversityCollapsibleSections";
import FileUpload from "../UILibrary/FileUpload";
import { useSelector, useDispatch } from "react-redux";
import { setDiversityInfo, updateDiversityCertifications } from "../../store/supplierFormDataSlice";

const customStyles = {
  menu: (provided) => ({
    ...provided,
    textAlign: "start",
    justifyContent: "center",
    background: "#FFF",
    borderRadius: "0.5rem",
    width: "350px",
    height: "auto", 
    zIndex: 9999, 
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999, 
  }),
  control: (provided, state) => ({
    ...provided,
    border: "none",
    textAlign: "start",
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
      : provided.boxShadow,
    minWidth: "200px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#7E7E7E",
  }),
  indicatorSeparator: () => ({
    display: "none", 
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#F7F7F7"
      : state.isFocused
      ? "#F7F7F7"
      : provided.backgroundColor,
    color: "#4A4A4A",
    padding: "5px 10px",
    borderRadius: "0.5rem",
    "&:active": {
      backgroundColor: "lightgray",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#B0B0B0",
    fontStyle: "italic",
  }),
};

const certAgencies = [
  "Affirmative Action Offices",
  "Civil Rights Offices",
  "Department of Transportation (DoT)",
  "Economic Development Agencies",
  "Unified Certification Program (UCP)",
  "Disability:IN",
  "National LGBTQ Chamber of Commerce (NGLCC)",
  "National Minority Supplier Development Council (NMSDC)",
  "National Veteran Business Development Council (NVBDC)",
  "National Women Business Owners Corporation (NWBOC)",
  "NaVOBA Veteran's Business Enterprise Certification (VBE)",
  "US Pan Asian American Chamber of Commerce (USPAACC)",
  "WEConnect Canada",
  "WEConnect International",
  "Women’s Business Enterprise National Council (WBENC)",
  "California Public Utilities Commission (CPUC) M/WBE Clearinghouse",
  "Canadian Aboriginal Minority Supplier Council",
  "Canadian Gay and Lesbian Chamber of Commerce (CGLCC)",
  "Minority Supplier Development UK (MSDUK)",
  "SBA 8(a) Program",
  "SBA Economically Disadvantaged Women-Owned Small Business (EDWOSB)",
  "SBA HUBZone Program",
  "SBA Women-Owned Small Business (WOSB)",
  "Standardized Self Certification Form - Service Disabled Veteran Owned Small Business (SDVOSB)",
  "Standardized Self Certification Form - Small Business (SDB)",
  "Standardized Self Certification Form - Veteran Owned Small Business (VOSB)",
  "VETBIZ - Service Disabled Veteran Owned Small Business (SDVOSB)",
  "VETBIZ - Veteran Owned Small Business (VOSB)",
];

const DiversityVerificationForm = ({ onNext, onSkip }) => {
  const [diversityCerts, setDiversityCerts] = useState([]);
  const userId = useSelector((state) => state.formData.supplierId);

  const diversityData = useSelector((state) => state.formData.diversityData.diversityCerts || []);

  useEffect(() => {
    if (Array.isArray(diversityData) && diversityData.length > 0) {
      const mappedCerts = diversityData.map((data) => ({
        id: userId,
        certName: data.certName || "",
        certId: data.certId || "",
        agency: data.agency || "",
        file: data.file || null,
      }));
      setDiversityCerts(mappedCerts);
    }
  }, [diversityData, userId]);


  const dispatch = useDispatch();


  const certifyingAgencyOptions = certAgencies.map((agency) => ({
    value: agency,
    label: agency,
  }));

  const handleCheckboxChange = (business) => {
    setDiversityCerts((prevCerts) => {
      const isAlreadySelected = prevCerts.find(
        (cert) => cert.certName === business
      );

      if (isAlreadySelected) {
        return prevCerts.filter((cert) => cert.certName !== business);
      } else {
        return [
          ...prevCerts,
          { certName: business, certId: "", agency: "", file: null },
        ];
      }
    });
  };

  const handleInputChange = (e, index, field) => {
    const updatedCerts = [...diversityCerts];
    updatedCerts[index][field] = e.target.value;
    setDiversityCerts(updatedCerts);
  };

  const handleFileChange = (e, index) => {
    const updatedCerts = [...diversityCerts];
    updatedCerts[index].file = e.target.files[0];
    setDiversityCerts(updatedCerts);
  };

  const handleDeleteRow = (index) => {
    setDiversityCerts((prevCerts) => {
      const updatedCerts = prevCerts.filter((_, i) => i !== index);
      dispatch(setDiversityInfo(updatedCerts));
      return updatedCerts;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    onNext();


    const certificationTypes =
    diversityCerts?.map((data) => ({
      certName: data.certName || "",
      certId: data.certId || "",
    }));

  const agencyDetails =
    diversityCerts.map((data) => ({
      agencyName: data.agency || "",
    })) || [];
  
    dispatch(setDiversityInfo({ diversityCerts }));
    dispatch(updateDiversityCertifications({
        id: userId,
        diversityInfo: diversityCerts,
      })
    );
  
    // onNext();
  };

  const renderTable = () => (
    <div className="overflow-x-scroll w-full sm:w-[850px]">
      <table className="border-collapse border-t border-b border-[#EEE] mt-4 w-full sm:w-1000 max-w-[1200px] mx-auto whitespace-nowrap">
        <thead>
          <tr>
            <th className="border-r border-[#EEE] px-4 py-2 text-[#757575] bg-[#FAFAFA] text-xs sm:text-sm">
              Selected
            </th>
            <th className="border-r border-[#EEE] px-4 py-2 text-[#757575] bg-[#FAFAFA] text-xs sm:text-sm">
              Cert ID
            </th>
            <th className="border-r border-[#EEE] px-4 py-2 text-[#757575] bg-[#FAFAFA] text-xs sm:text-sm w-56">
              Agency
            </th>
            <th className="border-r border-[#EEE] px-4 py-2 text-[#757575] bg-[#FAFAFA] text-xs sm:text-sm ">
              Upload File
            </th>
            <th className="px-4 py-2 text-[#757575] bg-[#FAFAFA] text-xs sm:text-sm"></th>
          </tr>
        </thead>
        <tbody>
          {diversityCerts.map((entry, index) => (
            <tr
              key={index}
              className="border-t border-b border-[#EEE] text-left items-center"
            >
              <td className="border-r border-[#EEE] px-2 py-1 text-xs sm:text-sm">
                {entry.certName}
              </td>
              <td className="border-r border-[#EEE] px-2 py-1 text-xs sm:text-sm">
                <input
                  type="text"
                  value={entry.certId}
                  placeholder="Enter Cert ID"
                  className="rounded bg-[#F7F7F7] p-1 sm:p-2 text-xs sm:text-sm"
                  onChange={(e) => handleInputChange(e, index, "certId")}
                />
              </td>
              <td className="border-r border-[#EEE] px-2 py-1 w-56">
                <Select
                  options={certifyingAgencyOptions}
                  value={
                    certifyingAgencyOptions.find(
                      (option) => option.value === entry.agency
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    handleInputChange(
                      { target: { value: selectedOption?.value || "" } },
                      index,
                      "agency"
                    );
                  }}
                  styles={customStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  placeholder="Select Agency"
                />
              </td>
              <td className="border-r border-[#EEE] px-2 py-1 text-xs sm:text-sm ">
                <FileUpload
                  id={`file-upload-${index}`}
                  handleFileChange={(e) => handleFileChange(e, index)}
                  existingFile={diversityCerts[index]?.file} 
                />
              </td>

              <td className="px-2 py-1 text-center text-xs sm:text-sm">
                <button
                  type="button"
                  onClick={() => handleDeleteRow(index)}
                  className="text-red-500 hover:text-red-700 flex items-center gap-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                  >
                    <path
                      d="M7 3.5H9C9 3.23478 8.89464 2.98043 8.70711 2.79289C8.51957 2.60536 8.26522 2.5 8 2.5C7.73478 2.5 7.48043 2.60536 7.29289 2.79289C7.10536 2.98043 7 3.23478 7 3.5ZM6 3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5C8.53043 1.5 9.03914 1.71071 9.41421 2.08579C9.78929 2.46086 10 2.96957 10 3.5H14C14.1326 3.5 14.2598 3.55268 14.3536 3.64645C14.4473 3.74021 14.5 3.86739 14.5 4C14.5 4.13261 14.4473 4.25979 14.3536 4.35355C14.2598 4.44732 14.1326 4.5 14 4.5H13.436L12.231 13.338C12.1493 13.9369 11.8533 14.486 11.3979 14.8835C10.9425 15.281 10.3585 15.5 9.754 15.5H6.246C5.64152 15.5 5.05751 15.281 4.6021 14.8835C4.14669 14.486 3.85073 13.9369 3.769 13.338L2.564 4.5H2C1.86739 4.5 1.74021 4.44732 1.64645 4.35355C1.55268 4.25979 1.5 4.13261 1.5 4C1.5 3.86739 1.55268 3.74021 1.64645 3.64645C1.74021 3.55268 1.86739 3.5 2 3.5H6ZM7 7C7 6.86739 6.94732 6.74021 6.85355 6.64645C6.75979 6.55268 6.63261 6.5 6.5 6.5C6.36739 6.5 6.24021 6.55268 6.14645 6.64645C6.05268 6.74021 6 6.86739 6 7V12C6 12.1326 6.05268 12.2598 6.14645 12.3536C6.24021 12.4473 6.36739 12.5 6.5 12.5C6.63261 12.5 6.75979 12.4473 6.85355 12.3536C6.94732 12.2598 7 12.1326 7 12V7ZM9.5 6.5C9.63261 6.5 9.75979 6.55268 9.85355 6.64645C9.94732 6.74021 10 6.86739 10 7V12C10 12.1326 9.94732 12.2598 9.85355 12.3536C9.75979 12.4473 9.63261 12.5 9.5 12.5C9.36739 12.5 9.24021 12.4473 9.14645 12.3536C9.05268 12.2598 9 12.1326 9 12V7C9 6.86739 9.05268 6.74021 9.14645 6.64645C9.24021 6.55268 9.36739 6.5 9.5 6.5ZM4.76 13.203C4.80908 13.5623 4.98664 13.8916 5.25984 14.1301C5.53304 14.3685 5.88337 14.5 6.246 14.5H9.754C10.1168 14.5002 10.4674 14.3689 10.7408 14.1304C11.0142 13.8919 11.1919 13.5625 11.241 13.203L12.427 4.5H3.573L4.76 13.203Z"
                      fill="#FF0004"
                    />
                  </svg>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <section className="flex flex-col items-center min-h-screen justify-start bg-white py-10 px-6">
      <header className="text-center mb-14">
        <h1 className="text-2xl font-semibold text-[#1D2639]">
          Diversity Data & Verification
        </h1>
        <p className="text-base font-medium text-[#7E7E7E] w-full sm:w-[572px] mt-2">
          Provide information about your company's diversity classifications and
          any supporting certifications. Sharing this data can open
          opportunities with buyers seeking to engage with diverse suppliers,
          promoting inclusivity and broadening your market reach.
        </p>
      </header>
      <form
        className="flex flex-col w-full sm:w-[572px] gap-4"
        aria-live="polite"
      >
        <CollapsibleSections onCheckboxChange={handleCheckboxChange} />
        {diversityCerts.length > 0 && renderTable()}
        <ContinueButton onClick={handleSubmit} label="Save and Continue" />
        <button
          type="button"
          className={`flex justify-center cursor-pointer items-center self-center w-full sm:w-[432px] h-14 p-5 rounded-[13px] text-center text-base font-medium border border-gray-300`}
          aria-label="Skip"
          onClick={onSkip}
        >
          Skip
        </button>
      </form>
    </section>
  );
};

export default DiversityVerificationForm;